/* ==========================================================================
   Cubone's Corner — theme.js
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  initDropdowns();
  initPredictiveSearch();
  initHero();
  initVariantPicker();
  initQtyControls();
  initAddToCart();
  initCartRowControls();
  initFooterMenu();
  initHamburgerMenu();
});

/* ---------- Mobile hamburger menu ---------- */
function initHamburgerMenu() {
  var btn = document.getElementById('hamburger-toggle');
  var panel = document.getElementById('site-header-collapsible');
  if (!btn || !panel) return;

  btn.addEventListener('click', function () {
    var isOpen = panel.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  // close the mobile menu after tapping a nav link
  panel.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      panel.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
  });

  // mobile search box: press Enter to go to the search results page
  var mobileSearch = document.getElementById('site-search-input-mobile');
  if (mobileSearch) {
    mobileSearch.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && mobileSearch.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(mobileSearch.value.trim());
      }
    });
  }
}

/* ---------- Generic dropdown toggles (search / account) ---------- */
function initDropdowns() {
  document.querySelectorAll('[data-dropdown-toggle]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var targetId = trigger.getAttribute('data-dropdown-toggle');
      var panel = document.getElementById(targetId);
      var isOpen = panel.classList.contains('is-open');
      document.querySelectorAll('.icon-dropdown__panel.is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
      if (!isOpen) panel.classList.add('is-open');
    });
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('.icon-dropdown__panel.is-open').forEach(function (p) {
      p.classList.remove('is-open');
    });
  });

  document.querySelectorAll('.icon-dropdown__panel').forEach(function (panel) {
    panel.addEventListener('click', function (e) { e.stopPropagation(); });
  });
}

/* ---------- Predictive search (Shopify's built-in suggest endpoint) ---------- */
function initPredictiveSearch() {
  var input = document.getElementById('site-search-input');
  if (!input) return;

  var resultsBox = document.getElementById('search-results');
  var emptyBox = document.getElementById('search-empty');
  var timer;

  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearTimeout(timer);

    if (!query) {
      resultsBox.innerHTML = '';
      resultsBox.style.display = 'none';
      emptyBox.style.display = 'none';
      return;
    }

    timer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          resultsBox.innerHTML = '';

          if (products.length === 0) {
            resultsBox.style.display = 'none';
            emptyBox.style.display = 'block';
            return;
          }

          emptyBox.style.display = 'none';
          resultsBox.style.display = 'flex';

          products.forEach(function (p) {
            var row = document.createElement('a');
            row.href = p.url;
            row.className = 'search-results__row';
            row.innerHTML =
              '<span class="search-results__name">' + p.title + '</span>' +
              '<span class="search-results__price">' + p.price + '</span>';
            resultsBox.appendChild(row);
          });
        })
        .catch(function () { /* fail silently */ });
    }, 220);
  });
}

/* ---------- Hero slideshow ---------- */
function initHero() {
  var hero = document.querySelector('[data-hero]');
  if (!hero) return;

  var slides = hero.querySelectorAll('.hero__slide');
  if (slides.length < 2) return;

  var current = 0;
  var interval;

  function show(index) {
    slides[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
  }

  function next() { show(current + 1); }
  function prev() { show(current - 1); }

  function startAutoplay() {
    interval = setInterval(next, 5000);
  }

  function resetAutoplay() {
    clearInterval(interval);
    startAutoplay();
  }

  var nextBtn = hero.querySelector('[data-hero-next]');
  var prevBtn = hero.querySelector('[data-hero-prev]');
  if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetAutoplay(); });
  if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetAutoplay(); });

  startAutoplay();
}

/* ---------- Product variant / size picker ---------- */
function initVariantPicker() {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var variantInput = form.querySelector('[name="id"]');
  var priceEl = document.querySelector('[data-product-price]');
  var addBtn = form.querySelector('[data-add-to-cart]');
  var variantsJson = document.getElementById('product-variants-json');
  var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

  document.querySelectorAll('.size-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.hasAttribute('disabled')) return;

      document.querySelectorAll('.size-pill').forEach(function (p) { p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');

      var size = pill.getAttribute('data-size');
      var match = variants.find(function (v) {
        return v.option1 === size || (v.options && v.options.indexOf(size) !== -1);
      });

      if (match) {
        variantInput.value = match.id;
        if (priceEl) priceEl.textContent = '$' + (match.price / 100).toFixed(0);
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.getAttribute('data-default-label') : 'Sold out';
      }
    });
  });
}

/* ---------- Quantity +/- controls (product page) ---------- */
function initQtyControls() {
  document.querySelectorAll('[data-qty-control]').forEach(function (control) {
    var input = control.querySelector('input[type="number"]');
    var minus = control.querySelector('[data-qty-minus]');
    var plus = control.querySelector('[data-qty-plus]');

    minus.addEventListener('click', function () {
      var val = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
    plus.addEventListener('click', function () {
      var val = parseInt(input.value || '1', 10) + 1;
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });
}

/* ---------- AJAX add to cart ---------- */
function initAddToCart() {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart]');
    var defaultLabel = btn.getAttribute('data-default-label') || btn.textContent;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: form.querySelector('[name="id"]').value,
        quantity: parseInt(form.querySelector('[name="quantity"]').value || '1', 10)
      })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = 'Added! \u2713';
        updateCartCount();
        setTimeout(function () { btn.textContent = defaultLabel; }, 1600);
      })
      .catch(function () {
        btn.textContent = 'Something went wrong';
        setTimeout(function () { btn.textContent = defaultLabel; }, 1600);
      });
  });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      var badge = document.getElementById('cart-count');
      if (!badge) return;
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    });
}

/* ---------- Cart page: quantity change / remove ---------- */
function initCartRowControls() {
  document.querySelectorAll('[data-cart-row]').forEach(function (row) {
    var key = row.getAttribute('data-key');
    var input = row.querySelector('input[type="number"]');
    var minus = row.querySelector('[data-qty-minus]');
    var plus = row.querySelector('[data-qty-plus]');
    var remove = row.querySelector('[data-remove]');

    function changeQty(newQty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(function () { window.location.reload(); });
    }

    if (minus) minus.addEventListener('click', function () {
      var val = Math.max(0, parseInt(input.value, 10) - 1);
      changeQty(val);
    });
    if (plus) plus.addEventListener('click', function () {
      changeQty(parseInt(input.value, 10) + 1);
    });
    if (remove) remove.addEventListener('click', function () {
      changeQty(0);
    });
  });
}

/* ---------- Footer "Terms and Policies" menu ---------- */
function initFooterMenu() {
  var trigger = document.querySelector('[data-footer-menu-toggle]');
  if (!trigger) return;
  var panel = document.getElementById('footer-menu-panel');

  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    panel.classList.toggle('is-open');
  });
  document.addEventListener('click', function () { panel.classList.remove('is-open'); });
  panel.addEventListener('click', function (e) { e.stopPropagation(); });
}
